import Grid from "@material-ui/core/Grid";
import React from "react";
import styled, { css } from "styled-components";

export interface FooterProps {
  children: React.ReactNode;
}

const StyledFooter = styled.footer(
  (props) => css`
    padding: ${props.theme.spacing(2)}px;
    background-color: ${props.theme.palette.grey["100"]};
    display: flex;

    ${props.theme.breakpoints.up("sm")} {
      justify-content: center;
    }
  `,
);

const Footer: React.FC<FooterProps> = ({ children }) => {
  return (
    <StyledFooter>
      <Grid item>{children}</Grid>
    </StyledFooter>
  );
};

export default Footer;
